import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import {
  LoginFormComponent,
  ResetPasswordFormComponent,
  CreateAccountFormComponent,
  ChangePasswordFormComponent,
} from "./shared/components";
import { AuthGuardService } from "./shared/services";
import { HomeComponent } from "./pages/home/home.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { TasksComponent } from "./pages/tasks/tasks.component";
import { DxDataGridModule, DxFormModule } from "devextreme-angular";
import { PasswordChangeComponent } from "./pages/password-change/password-change.component";
import { ForgotPasswordFormComponent } from "./shared/components/forgot-password-form/forgot-password-form.component";
import { NewPasswordFormComponent } from "./shared/components/new-password-form/new-password.component";
import { OTPFormComponent } from "./shared/components/otp-form/otp-form.component";
import { DashboardComponent } from "./views/common/dashboard/dashboard.component";
import { NotificationComponent } from "./shared/components/notification/notification.component";
import { SUBMENU_ID } from "./classes/domain/constants";
import { AboutMasterComponent } from "./views/Masters/landing-page/about/about-master/about-master.component";
import { AboutMasterDetailsComponent } from "./views/Masters/landing-page/about/about-master-details/about-master-details.component";
import { WorkGalleryMasterComponent } from "./views/Masters/landing-page/work-gallery/work-gallery-master/work-gallery-master.component";
import { WorkGalleryMasterDetailsComponent } from "./views/Masters/landing-page/work-gallery/work-gallery-master-details/work-gallery-master-details.component";
import { TrainingVideoMasterComponent } from "./views/Masters/landing-page/training-video/training-video-master/training-video-master.component";
import { TrainingVideoMasterDetailsComponent } from "./views/Masters/landing-page/training-video/training-video-master-details/training-video-master-details.component";
import { HealthDepartmentProfileMasterComponent } from "./views/Masters/landing-page/health-department-profile/health-department-profile-master/health-department-profile-master.component";
import { HealthDepartmentProfileMasterDetailsComponent } from "./views/Masters/landing-page/health-department-profile/health-department-profile-master-details/health-department-profile-master-details.component";
import { LandingPageComponent } from "./shared/components/landing-page/landing-page.component";
import { PrivacyPolicyComponent } from "./views/common/privacy-policy/privacy-policy.component";
import { TermsAndConditionsComponent } from "./views/common/terms-and-conditions/terms-and-conditions.component";


export const routes: Routes = [
  {
    path: "tasks",
    component: TasksComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "Profile",
    component: ProfileComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "Change_Password",
    component: PasswordChangeComponent,
    // canActivate: [AuthGuardService]
  },
  {
    path: "forgot-password",
    component: ForgotPasswordFormComponent,
    // canActivate: [AuthGuardService],
  },

  // {
  //   path: "Change-Expired-Password",
  //   component: ChangePasswordComponent,
  //   // canActivate: [AuthGuardService],
  // },

  // Masters
  // {
  //   path: `${SUBMENU_ID.STATE_MASTER}`,
  //   component: StateMasterComponent,
  //   // component: DemoStateMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.STATE_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/state-master/state-master.component").then(
        (m) => m.StateMasterComponent,
        // import("./views/demo/demo-state-master/demo-state-master.component").then(
        //   (m) => m.DemoStateMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  // {
  //   path: `${SUBMENU_ID.ZONE_MASTER}`,
  //   component: ZoneMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.ZONE_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/zone-master/zone-master/zone-master.component").then(
        (m) => m.ZoneMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.DISTRICT_MASTER}`,
  //   component: DistrictMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.DISTRICT_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/district-master/district-master/district-master.component").then(
        (m) => m.DistrictMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  // {
  //   path: `${SUBMENU_ID.BLOCK_MASTER}`,
  //   component: BlockMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.BLOCK_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/block-master/block-master/block-master.component").then(
        (m) => m.BlockMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.PHC_MASTER}`,
  //   component: PhcMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.PHC_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/phc-master/phc-master/phc-master.component").then(
        (m) => m.PhcMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.SC_MASTER}`,
  //   component: ScMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.SC_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/sc-master/sc-master/sc-master.component").then(
        (m) => m.ScMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.BLOCK_MASTER}`,
  //   component: BlockMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.BLOCK_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/block-master/block-master/block-master.component").then(
        (m) => m.BlockMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.VILLAGE_MASTER}`,
  //   component: VillageMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.VILLAGE_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/village-master/village-master/village-master.component").then(
        (m) => m.VillageMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.DHO_POST_MASTER}`,
  //   component: DhoPostsMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.DHO_POST_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/sanctionedposts/dhoposts/dho-posts-master/dho-posts-master.component").then(
        (m) => m.DhoPostsMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  // {
  //   path: `${SUBMENU_ID.DHO_POST_MASTER_DETAILS}`,
  //   component: DhoPostsMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.DHO_POST_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/sanctionedposts/dhoposts/dho-posts-master-details/dho-posts-master-details.component").then(
        (m) => m.DhoPostsMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },
  // {
  //     path: `${SUBMENU_ID.DCM_POST_MASTER}`,
  //     component: DcmPostsMasterComponent,
  //     canActivate: [AuthGuardService],
  //   },

  {
    path: `${SUBMENU_ID.DCM_POST_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/sanctionedposts/dcmposts/dcm-posts-master/dcm-posts-master.component").then(
        (m) => m.DcmPostsMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.DCM_POST_MASTER_DETAILS}`,
  //   component: DcmPostsMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.DCM_POST_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/dcm-master/dcm-master-details/dcm-master-details.component").then(
        (m) => m.DcmMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.BCM_POST_MASTER}`,
  //   component: BcmPostsMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.BCM_POST_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/sanctionedposts/bcmposts/bcm-posts-master/bcm-posts-master.component").then(
        (m) => m.BcmPostsMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.BCM_POST_MASTER_DETAILS}`,
  //   component: BcmMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.BCM_POST_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/bcm-master/bcm-master-details/bcm-master-details.component").then(
        (m) => m.BcmMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.AF_POST_MASTER}`,
  //   component: AfpostsMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.AF_POST_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/sanctionedposts/afposts/afposts-master/afposts-master.component").then(
        (m) => m.AfpostsMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.AF_POST_MASTER_DETAILS}`,
  //   component: AfpostsMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  {
    path: `${SUBMENU_ID.AF_POST_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/sanctionedposts/afposts/afposts-master-details/afposts-master-details.component").then(
        (m) => m.AfpostsMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.ASHA_POST_MASTER}`,
  //   component: AshaPostMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  {
    path: `${SUBMENU_ID.ASHA_POST_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/sanctionedposts/ashapost/asha-post-master/asha-post-master.component").then(
        (m) => m.AshaPostMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.CATEGORY_MASTER}`,
  //   component: CategoryMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.VIMA_YOJANA_MASTER}`,
  //   component: VimaYojanaMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ROLES_MASTER}`,
  //   component: RolesMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RELATION_MASTER}`,
  //   component: RelationMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.CATEGORY_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/category-master/category-master/category-master.component").then(
        (m) => m.CategoryMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.VIMA_YOJANA_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/vima-yojana-master/vima-yojana-master/vima-yojana-master.component").then(
        (m) => m.VimaYojanaMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.ROLES_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/roles-master/roles-master.component").then(
        (m) => m.RolesMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.RELATION_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/relation-master/relation-master/relation-master.component").then(
        (m) => m.RelationMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // Asha Master //
  // {
  //   path: `${SUBMENU_ID.ASHA_MASTER}`,
  //   component: AshaMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_MASTER_DETAILS}`,
  //   component: AshaMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_MASTER}`,
  //   component: BfMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DHO_MASTER}`,
  //   component: DhoMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DHO_MASTER_DETAILS}`,
  //   component: DhoMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.ASHA_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/asha-master/asha-master/asha-master.component").then(
        (m) => m.AshaMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.ASHA_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/asha-master/asha-master-details/asha-master-details.component").then(
        (m) => m.AshaMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.AF_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/bf-master/bf-master/bf-master.component").then(
        (m) => m.BfMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.DHO_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/dho-master/dho-master/dho-master.component").then(
        (m) => m.DhoMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.DHO_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/dho-master/dho-master-details/dho-master-details.component").then(
        (m) => m.DhoMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.THO_MASTER}`,
  //   component: ThoMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.THO_MASTER_DETAILS}`,
  //   component: ThoMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DCM_MASTER}`,
  //   component: DcmMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DCM_MASTER_DETAILS}`,
  //   component: DcmMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BCM_MASTER}`,
  //   component: BcmMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BCM_MASTER_DETAILS}`,
  //   component: BcmMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.THO_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/tho-master/tho-master/tho-master.component").then(
        (m) => m.ThoMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.THO_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/tho-master/tho-master-details/tho-master-details.component").then(
        (m) => m.ThoMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.DCM_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/dcm-master/dcm-master/dcm-master.component").then(
        (m) => m.DcmMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.DCM_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/dcm-master/dcm-master-details/dcm-master-details.component").then(
        (m) => m.DcmMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.BCM_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/bcm-master/bcm-master/bcm-master.component").then(
        (m) => m.BcmMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.BCM_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/bcm-master/bcm-master-details/bcm-master-details.component").then(
        (m) => m.BcmMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.MO_MASTER}`,
  //   component: MoMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MO_MASTER_DETAILS}`,
  //   component: MoMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_MASTER_DETAILS}`,
  //   component: BfMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_CENTRAL_INCENTIVE_MASTER}`,
  //   component: AfCentralIncentiveMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.BIRTH_DEFECT_TYPE_MASTER}`,
  //   component: BirthDefectTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.MO_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/mo-master/mo-master/mo-master.component").then(
        (m) => m.MoMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.MO_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/mo-master/mo-master-details/mo-master-details.component").then(
        (m) => m.MoMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.AF_MASTER_DETAILS}`,
    loadComponent: () =>
      import("./views/Masters/bf-master/bf-master-details/bf-master-details.component").then(
        (m) => m.BfMasterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },
  // {
  //   path: `${SUBMENU_ID.AF_CENTRAL_INCENTIVE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/af-central-incentive-master/af-central-incentive-master/af-central-incentive-master.component").then(
  //       (m) => m.AfCentralIncentiveMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BIRTH_DEFECT_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/RBSK/birth-defect-type-master/birth-defect-type-master/birth-defect-type-master.component").then(
  //       (m) => m.BirthDefectTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.AF_STATE_INCENTIVE_MASTER}`,
  //   component: AfStateIncentiveMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.TRAINING_GROUP_MASTER}`,
  //   component: TrainingGroupMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.TRAINING_TYPE_MASTER}`,
  //   component: TrainingTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.GRIEVANCE_GROUP_MASTER}`,
  //   component: GrievanceGroupMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.GRIEVANCE_TYPE_MASTER}`,
  //   component: GrievanceTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.AF_STATE_INCENTIVE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/af-state-incentive-master/af-state-incentive-master/af-state-incentive-master.component").then(
  //       (m) => m.AfStateIncentiveMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.TRAINING_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/training-master/training-group-master/training-group-master/training-group-master.component").then(
  //       (m) => m.TrainingGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.TRAINING_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/training-master/training-type-master/training-type-master/training-type-master.component").then(
  //       (m) => m.TrainingTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.GRIEVANCE_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/grievance-mentoring-master/grievance-group-master/grievance-group-master/grievance-group-master.component").then(
  //       (m) => m.GrievanceGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.GRIEVANCE_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/grievance-mentoring-master/grievance-type-master/grievance-type-master/grievance-type-master.component").then(
  //       (m) => m.GrievanceTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.PERFORMANCE_GROUP_MASTER}`,
  //   component: PerformanceGroupMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.PERFORMANCE_TYPE_MASTER}`,
  //   component: PerformanceTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_GROUP_MASTER}`,
  //   component: HbncGroupMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_KIT_GROUP}`,
  //   component: HbncKitGroupComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_TYPE_MASTER}`,
  //   component: HbncTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.PERFORMANCE_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/performance-indicator-master/performance-indicator-group/performance-group-master/performance-group-master.component").then(
  //       (m) => m.PerformanceGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.PERFORMANCE_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/performance-indicator-master/performance-indicator-type/performance-type-master/performance-type-master.component").then(
  //       (m) => m.PerformanceTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/hbnc-master/hbnc-group-master/hbnc-group-master/hbnc-group-master.component").then(
  //       (m) => m.HbncGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_KIT_GROUP}`,
  //   loadComponent: () =>
  //     import("./views/Masters/hbnc-kit-group-master/hbnc-kit-group/hbnc-kit-group.component").then(
  //       (m) => m.HbncKitGroupComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/hbnc-master/hbnc-type-master/hbnc-type-master/hbnc-type-master.component").then(
  //       (m) => m.HbncTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.HBYC_GROUP_MASTER}`,
  //   component: HbycGroupMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBYC_TYPE_MASTER}`,
  //   component: HbycTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBYC_UNTRAINED_GROUP_MASTER}`,
  //   component: HbycUntrainedGroupMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBYC_UNTRAINED_TYPE_MASTER}`,
  //   component: HbycUntrainedTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.HBYC_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/hbyc-master/hbyc-group-master/hbyc-group-master/hbyc-group-master.component").then(
  //       (m) => m.HbycGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBYC_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/hbyc-master/hbyc-type-master/hbyc-type-master/hbyc-type-master.component").then(
  //       (m) => m.HbycTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBYC_UNTRAINED_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/hbyc-untrained-master/hbyc-untrained-group/hbyc-untrained-group-master/hbyc-untrained-group-master.component").then(
  //       (m) => m.HbycUntrainedGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBYC_UNTRAINED_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/hbyc-untrained-master/hbyc-untrained-type/hbyc-untrained-type-master/hbyc-untrained-type-master.component").then(
  //       (m) => m.HbycUntrainedTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ACTIVITY_RATE_MASTER}`,
  //   component: PerformanceIndicatorTypeActivityRateMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE_GROUP_MASTER}`,
  //   component: CentralIncentiveGroupMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE_TYPE_MASTER}`,
  //   component: CentralIncentiveTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_GROUP_MASTER}`,
  //   component: StateIncentiveGroupMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_TYPE_MASTER}`,
  //   component: StateIncentiveTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RAJYASHASAN_MANDHAN_MASTER}`,
  //   component: RajyashasanMandhanMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // // Test
  // {
  //   path: `${SUBMENU_ID.TEST_COMPONENT}`,
  //   component: TestComponentComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.PROMOTION_MASTER}`,
  //   component: PromotionMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.PROMOTION_MASTER_DETAILS}`,
  //   component: PromotionMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.TERMINATION_MASTER}`,
  //   component: TerminationMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.TERMINATION_MASTER_DETAILS}`,
  //   component: TerminationMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RESIGNATION_MASTER}`,
  //   component: ResignationMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RESIGNATION_MASTER_DETAILS}`,
  //   component: ResignationMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // // Mother Meeting
  // {
  //   path: `${SUBMENU_ID.MOTHER_MEETING_GROUP_MASTER}`,
  //   component: MotherMeetingGroupMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MOTHER_MEETING_GROUP_MASTER_DETAILS}`,
  //   component: MotherMeetingGroupMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.MOTHER_MEETING_TYPE_MASTER}`,
  //   component: MotherMeetingTypeMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MOTHER_MEETING_TYPE_MASTER_DETAILS}`,
  //   component: MotherMeetingTypeMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ACTIVITY_RATE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/performance-indicator-master/performance-indicator-type-activity-rate/activity-rate-master/performance-indicator-type-activity-rate-master.component").then(
  //       (m) => m.PerformanceIndicatorTypeActivityRateMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/central-incentive-master/central-incentive-group/central-incentive-group-master/central-incentive-group-master.component").then(
  //       (m) => m.CentralIncentiveGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/central-incentive-master/central-incentive-type/central-incentive-type-master/central-incentive-type-master.component").then(
  //       (m) => m.CentralIncentiveTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/state-incentive-master/state-incentive-group/state-incentive-group-master/state-incentive-group-master.component").then(
  //       (m) => m.StateIncentiveGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/state-incentive-master/state-incentive-type/state-incentive-type-master/state-incentive-type-master.component").then(
  //       (m) => m.StateIncentiveTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RAJYASHASAN_MANDHAN_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/rajyashasan-mandhan-master/rajyashasan-mandhan-master/rajyashasan-mandhan-master.component").then(
  //       (m) => m.RajyashasanMandhanMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.TEST_COMPONENT}`,
  //   loadComponent: () =>
  //     import("./views/Masters/test-component/test-component.component").then(
  //       (m) => m.TestComponentComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.PROMOTION_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/promotion/promotion-master/promotion-master.component").then(
  //       (m) => m.PromotionMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.PROMOTION_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/promotion/promotion-master-details/promotion-master-details.component").then(
  //       (m) => m.PromotionMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.TERMINATION_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/termination/termination-master/termination-master.component").then(
  //       (m) => m.TerminationMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.TERMINATION_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/termination/termination-master-details/termination-master-details.component").then(
  //       (m) => m.TerminationMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RESIGNATION_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/resignation-master/resignation-master/resignation-master.component").then(
  //       (m) => m.ResignationMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RESIGNATION_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/resignation-master/resignation-master-details/resignation-master-details.component").then(
  //       (m) => m.ResignationMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MOTHER_MEETING_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/mother-meeting-master/mother-meeting-group-master/mother-meeting-group-master/mother-meeting-group-master.component").then(
  //       (m) => m.MotherMeetingGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MOTHER_MEETING_GROUP_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/mother-meeting-master/mother-meeting-group-master/mother-meeting-group-master-details/mother-meeting-group-master-details.component").then(
  //       (m) => m.MotherMeetingGroupMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MOTHER_MEETING_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/mother-meeting-master/mother-meeting-type-master/mother-meeting-type-master/mother-meeting-type-master.component").then(
  //       (m) => m.MotherMeetingTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MOTHER_MEETING_TYPE_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/mother-meeting-master/mother-meeting-type-master/mother-meeting-type-master-details/mother-meeting-type-master-details.component").then(
  //       (m) => m.MotherMeetingTypeMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // // Mother Meeting End

  // // Spacing Of Birth
  // // {
  // //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_GROUP_MASTER}`,
  // //   component: SpacingOfBirthGroupMasterComponent,
  // //   canActivate: [AuthGuardService],
  // // },
  // // {
  // //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_GROUP_MASTER_DETAILS}`,
  // //   component: SpacingOfBirthGroupMasterDetailsComponent,
  // //   canActivate: [AuthGuardService],
  // // },

  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/spacing-of-birth/spacing-of-birth-group-master/spacing-of-birth-group-master/spacing-of-birth-group-master.component").then(
  //       (m) => m.SpacingOfBirthGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_GROUP_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/spacing-of-birth/spacing-of-birth-group-master/spacing-of-birth-group-master-details/spacing-of-birth-group-master-details.component").then(
  //       (m) => m.SpacingOfBirthGroupMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // // {
  // //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_TYPE_MASTER}`,
  // //   component: SpacingOfBirthTypeMasterComponent,
  // //   canActivate: [AuthGuardService],
  // // },
  // // {
  // //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_TYPE_MASTER_DETAILS}`,
  // //   component: SpacingOfBirthTypeMasterDetailsComponent,
  // //   canActivate: [AuthGuardService],
  // // },

  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/spacing-of-birth/spacing-of-birth-type-master/spacing-of-birth-type-master/spacing-of-birth-type-master.component").then(
  //       (m) => m.SpacingOfBirthTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_TYPE_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/spacing-of-birth/spacing-of-birth-type-master/spacing-of-birth-type-master-details/spacing-of-birth-type-master-details.component").then(
  //       (m) => m.SpacingOfBirthTypeMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // // Spacing Of Birth End

  // // Iodine Testing start
  // // {
  // //   path: `${SUBMENU_ID.IODINE_TESTING_GROUP_MASTER}`,
  // //   component: IodineTestingGroupMasterComponent,
  // //   canActivate: [AuthGuardService],
  // // },
  // // {
  // //   path: `${SUBMENU_ID.IODINE_TESTING_GROUP_MASTER_DETAILS}`,
  // //   component: IodineTestingGroupMasterDetailsComponent,
  // //   canActivate: [AuthGuardService],
  // // },

  // // {
  // //   path: `${SUBMENU_ID.IODINE_TESTING_TYPE_MASTER}`,
  // //   component: IodineTestingTypeMasterComponent,
  // //   canActivate: [AuthGuardService],
  // // },
  // // {
  // //   path: `${SUBMENU_ID.IODINE_TESTING_TYPE_MASTER_DETAILS}`,
  // //   component: IodineTestingTypeMasterDetailsComponent,
  // //   canActivate: [AuthGuardService],
  // // },

  // // // Iodine Testing End

  // // //Sanitary Napkin rate start
  // // {
  // //   path: `${SUBMENU_ID.SANITARY_NAPKIN_RATE_MASTER}`,
  // //   component: SanitaryNapkinRateMasterComponent,
  // //   canActivate: [AuthGuardService],
  // // },
  // // {
  // //   path: `${SUBMENU_ID.SANITARY_NAPKIN_RATE_MASTER_DETAILS}`,
  // //   component: SanitaryNapkinRateMasterDetailsComponent,
  // //   canActivate: [AuthGuardService],
  // // },

  // // //Visit Type
  // // {
  // //   path: `${SUBMENU_ID.VISIT_TYPE_MASTER}`,
  // //   component: VisitTypeMasterComponent,
  // //   canActivate: [AuthGuardService],
  // // },
  // // {
  // //   path: `${SUBMENU_ID.VISIT_TYPE_MASTER_DETAILS}`,
  // //   component: VisitTypeMasterDetailsComponent,
  // //   canActivate: [AuthGuardService],
  // // },

  // // //Report Configuration
  // // {
  // //   path: `${SUBMENU_ID.REPORT_CONFIGURATION_MASTER}`,
  // //   component: ReportConfigurationComponent,
  // //   canActivate: [AuthGuardService],
  // // },
  // // {
  // //   path: `${SUBMENU_ID.REPORT_CONFIGURATION_MASTER_DETAILS}`,
  // //   component: ReportConfigurationDetailsComponent,
  // //   canActivate: [AuthGuardService],
  // // },

  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_GROUP_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/iodine-testing-master/iodine-testing-group-master/iodine-testing-group-master/iodine-testing-group-master.component").then(
  //       (m) => m.IodineTestingGroupMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_GROUP_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/iodine-testing-master/iodine-testing-group-master/iodine-testing-group-master-details/iodine-testing-group-master-details.component").then(
  //       (m) => m.IodineTestingGroupMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/iodine-testing-master/iodine-testing-type-master/iodine-testing-type-master/iodine-testing-type-master.component").then(
  //       (m) => m.IodineTestingTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_TYPE_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/iodine-testing-master/iodine-testing-type-master/iodine-testing-type-master-details/iodine-testing-type-master-details.component").then(
  //       (m) => m.IodineTestingTypeMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // // Sanitary Napkin Rate
  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_RATE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/sanitary-napkin-rate-master/sanitary-napkin-rate-master/sanitary-napkin-rate-master.component").then(
  //       (m) => m.SanitaryNapkinRateMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_RATE_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/sanitary-napkin-rate-master/sanitary-napkin-rate-master-details/sanitary-napkin-rate-master-details.component").then(
  //       (m) => m.SanitaryNapkinRateMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // // Visit Type
  // {
  //   path: `${SUBMENU_ID.VISIT_TYPE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/visit-type/visit-type-master/visit-type-master.component").then(
  //       (m) => m.VisitTypeMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.VISIT_TYPE_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/visit-type/visit-type-master-details/visit-type-master-details.component").then(
  //       (m) => m.VisitTypeMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // // Report Configuration
  // {
  //   path: `${SUBMENU_ID.REPORT_CONFIGURATION_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/Masters/report-configuration/report-configuration/report-configuration.component").then(
  //       (m) => m.ReportConfigurationComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.REPORT_CONFIGURATION_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/Masters/report-configuration/report-configuration-details/report-configuration-details.component").then(
  //       (m) => m.ReportConfigurationDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  //Sanitary Napkin rate end

  // Landing Page
  {
    path: `${SUBMENU_ID.ABOUT_MASTER}`,
    component: AboutMasterComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.ABOUT_MASTER_DETAILS}`,
    component: AboutMasterDetailsComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: `${SUBMENU_ID.WORK_GALLERY_MASTER}`,
    component: WorkGalleryMasterComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.WORK_GALLERY_MASTER_DETAILS}`,
    component: WorkGalleryMasterDetailsComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: `${SUBMENU_ID.TRAINING_VIDEO_MASTER}`,
    component: TrainingVideoMasterComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.TRAINING_VIDEO_MASTER_DETAILS}`,
    component: TrainingVideoMasterDetailsComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: `${SUBMENU_ID.HEALTH_DEPARTMENT_PROFILE_MASTER}`,
    component: HealthDepartmentProfileMasterComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.HEALTH_DEPARTMENT_PROFILE_MASTER_DETAILS}`,
    component: HealthDepartmentProfileMasterDetailsComponent,
    canActivate: [AuthGuardService],
  },
  // Landing Page end

  //Transaction

  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_FORM}`,
  //   component: AshaTrainingFormComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_FORM_DETAILS}`,
  //   component: AshaTrainingFormDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_HR_TRANSACTION}`,
  //   component: HrTransactionComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_HR_TRANSACTION_DETAILS}`,
  //   component: HRTransactionDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_REPORT}`,
  //   component: AshaTrainingReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_REPORT_DETAILS}`,
  //   component: AshaTrainingReportDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.AF_TRAINING_REPORT}`,
  //   component: BFTrainingReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_TRAINING_REPORT_DETAILS}`,
  //   component: BFTrainingReportDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.EDIT_REQUEST_FORM}`,
  //   component: EditRequestFormComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EDIT_REQUEST_APPROVAL_FORM_DETAILS}`,
  //   component: EditRequestFormDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EDIT_REQUEST_APPROVAL_FORM}`,
  //   component: RequestApprovalFormComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EDIT_REQUEST_APPROVAL_FORM_DETAILS}`,
  //   component: RequestApprovalFormDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.AF_CENTRAL_INCENTIVE_TRANSACTION}`,
  //   component: AFCentralIncentiveComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_CENTRAL_INCENTIVE_TRANSACTION_DETAILS}`,
  //   component: AFCentralIncentiveDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_STATE_INCENTIVE_MASTER}`,
  //   component: AFStateIncentiveComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_DETAILS}`,
  //   component: AFStateIncentiveDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ASHA_PERFORMANCE_FORM}`,
  //   component: AshaPerformanceFormComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_PERFORMANCE_FORM_DETAILS}`,
  //   component: AshaPerformanceFormDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE}`,
  //   component: CentralIncentiveComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE_DETAILS}`,
  //   component: CentralIncentiveDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_TRANSACTION}`,
  //   component: StateIncentiveComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_TRANSACTION_DETAILS}`,
  //   component: StateIncentiveDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBNC_TRANSACTION}`,
  //   component: MonthlyHbncReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBNC_TRANSACTION_DETAILS}`,
  //   component: MonthlyHbncReportDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBNC_REPORT_DETAILS}`,
  //   component: MonthlyHbncReportDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_HBNC_TRANSACTION}`,
  //   component: AfHbncTransactionComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_HBNC_TRANSACTION_DETAILS}`,
  //   component: AfHbncTransactionDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBYC_TRANSACTION}`,
  //   component: MonthlyHbycReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBYC_TRANSACTION_DETAILS}`,
  //   component: MonthlyHbycReportDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBYC_REPORT_MAIN}`,
  //   component: HbycTrainedAshaReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBYC_REPORT_DETAILS}`,
  //   component: MonthlyHbycReportDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBYC_UNTRAINED_ASHA_REPORT}`,
  //   component: HbycUntrainedAshaReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBYC_UNTRAINED_ASHA_REPORT_DETAILS}`,
  //   component: HbycUntrainedAshaReportDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.GRIEVANCE_MENTORING_TRANSACTION}`,
  //   component: GrievanceMonitoringReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.GRIEVANCE_MONITORING_TRANSACTION_DETAILS}`,
  //   component: GrievanceMonitoringReportDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_FORM}`,
  //   loadComponent: () =>
  //     import("./views/transaction/asha-training-form/asha-training-form/asha-training-form.component").then(
  //       (m) => m.AshaTrainingFormComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_FORM_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/asha-training-form/asha-training-form-details/asha-training-form-details.component").then(
  //       (m) => m.AshaTrainingFormDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_HR_TRANSACTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/asha-hr/asha-hr-transaction/asha-hr-transaction.component").then(
  //       (m) => m.HrTransactionComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_HR_TRANSACTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/asha-hr/asha-hr-transaction-details/asha-hr-transaction-details.component").then(
  //       (m) => m.HRTransactionDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/transaction/asha-training-report/asha-training-report/asha-training-report.component").then(
  //       (m) => m.AshaTrainingReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_REPORT_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/asha-training-report/asha-training-report-details/asha-training-report-details.component").then(
  //       (m) => m.AshaTrainingReportDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_TRAINING_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/transaction/bf-training-report/bf-training-report/bf-training-report.component").then(
  //       (m) => m.BFTrainingReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_TRAINING_REPORT_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/bf-training-report/bf-training-report-details/bf-training-report-details.component").then(
  //       (m) => m.BFTrainingReportDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EDIT_REQUEST_FORM}`,
  //   loadComponent: () =>
  //     import("./views/transaction/edit-request-form/edit-request-form/edit-request-form.component").then(
  //       (m) => m.EditRequestFormComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EDIT_REQUEST_APPROVAL_FORM_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/edit-request-form/edit-request-form-details/edit-request-form-details.component").then(
  //       (m) => m.EditRequestFormDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EDIT_REQUEST_APPROVAL_FORM}`,
  //   loadComponent: () =>
  //     import("./views/transaction/request-approval-form/request-approval-form/request-approval-form.component").then(
  //       (m) => m.RequestApprovalFormComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EDIT_REQUEST_APPROVAL_FORM_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/request-approval-form/request-approval-form-details/request-approval-form-details.component").then(
  //       (m) => m.RequestApprovalFormDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_CENTRAL_INCENTIVE_TRANSACTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/af-central-incentive/afcentral-incentive/afcentral-incentive.component").then(
  //       (m) => m.AFCentralIncentiveComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_CENTRAL_INCENTIVE_TRANSACTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/af-central-incentive/afcentral-incentive-details/afcentral-incentive-details.component").then(
  //       (m) => m.AFCentralIncentiveDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_STATE_INCENTIVE_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/transaction/af-state-incentive/afstate-incentive/afstate-incentive.component").then(
  //       (m) => m.AFStateIncentiveComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/af-state-incentive/afstate-incentive-details/afstate-incentive-details.component").then(
  //       (m) => m.AFStateIncentiveDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_PERFORMANCE_FORM}`,
  //   loadComponent: () =>
  //     import("./views/transaction/asha-performance-form/asha-performance-form/asha-performance-form.component").then(
  //       (m) => m.AshaPerformanceFormComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_PERFORMANCE_FORM_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/asha-performance-form/asha-performance-form-details/asha-performance-form-details.component").then(
  //       (m) => m.AshaPerformanceFormDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE}`,
  //   loadComponent: () =>
  //     import("./views/transaction/central-incentive/central-incentive/central-incentive.component").then(
  //       (m) => m.CentralIncentiveComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/central-incentive/central-incentive-details/central-incentive-details.component").then(
  //       (m) => m.CentralIncentiveDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_TRANSACTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/state-incentive/state-incentive/state-incentive.component").then(
  //       (m) => m.StateIncentiveComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_TRANSACTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/state-incentive/state-incentive-details/state-incentive-details.component").then(
  //       (m) => m.StateIncentiveDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBNC_TRANSACTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/monthly-hbnc-report/monthly-hbnc-report/monthly-hbnc-report.component").then(
  //       (m) => m.MonthlyHbncReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBNC_TRANSACTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/monthly-hbnc-report/monthly-hbnc-report-details/monthly-hbnc-report-details.component").then(
  //       (m) => m.MonthlyHbncReportDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.HBYC_UNTRAINED_ASHA_REPORT_DETAILS}`,
  //   component: HbycUntrainedAshaComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EMPLOYEE_STATE_INCENTIVE_TRANSACTION}`,
  //   component: EmployeeStateIncentiveTransactionComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EMPLOYEE_STATE_INCENTIVE_TRANSACTION_DETAILS}`,
  //   component: EmployeeStateIncentiveTransactionDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.DEVELOPMENTAL_DELAY_CHILDREN}`,
  //   component: DevelopmentalDelayChildrenComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEVELOPMENTAL_DELAY_CHILDREN_DETAILS}`,
  //   component: DevelopmentalDelayChildrenDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.HBYC_UNTRAINED_ASHA_REPORT_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/reports/hbyc-untrained-asha/hbyc-untrained-asha.component").then(
  //       (m) => m.HbycUntrainedAshaComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EMPLOYEE_STATE_INCENTIVE_TRANSACTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/employee-state-incentive/employee-state-incentive-transaction/employee-state-incentive-transaction.component").then(
  //       (m) => m.EmployeeStateIncentiveTransactionComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.EMPLOYEE_STATE_INCENTIVE_TRANSACTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/employee-state-incentive/employee-state-incentive-transaction-details/employee-state-incentive-transaction-details.component").then(
  //       (m) => m.EmployeeStateIncentiveTransactionDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEVELOPMENTAL_DELAY_CHILDREN}`,
  //   loadComponent: () =>
  //     import("./views/transaction/developmental-delay-children/developmental-delay-children/developmental-delay-children.component").then(
  //       (m) => m.DevelopmentalDelayChildrenComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEVELOPMENTAL_DELAY_CHILDREN_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/developmental-delay-children/developmental-delay-children-details/developmental-delay-children-details.component").then(
  //       (m) => m.DevelopmentalDelayChildrenDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.RBSK_TRANSACTION}`,
  //   component: RbskTansactionComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RBSK_TRANSACTION_DETAILS}`,
  //   component: RbskTansactionDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEFECTIVE_CHILDREN}`,
  //   component: DefectiveChildrenComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEFECTIVE_CHILDREN_DETAILS}`,
  //   component: DefectiveChildrenDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MAA_MEETING}`,
  //   component: MaaMeetingComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MAA_MEETING_DETAILS}`,
  //   component: MaaMeetingDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_TRANSACTION}`,
  //   component: IodineTestingComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_TRANSACTION_DETAILS}`,
  //   component: IodineTestingDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.RBSK_TRANSACTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/rbsk-transaction/rbsk-tansaction/rbsk-tansaction.component").then(
  //       (m) => m.RbskTansactionComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RBSK_TRANSACTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/rbsk-transaction/rbsk-tansaction-details/rbsk-tansaction-details.component").then(
  //       (m) => m.RbskTansactionDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEFECTIVE_CHILDREN}`,
  //   loadComponent: () =>
  //     import("./views/transaction/defective-children/defective-children/defective-children.component").then(
  //       (m) => m.DefectiveChildrenComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEFECTIVE_CHILDREN_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/defective-children/defective-children-details/defective-children-details.component").then(
  //       (m) => m.DefectiveChildrenDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MAA_MEETING}`,
  //   loadComponent: () =>
  //     import("./views/transaction/maa-meeting/maa-meeting/maa-meeting.component").then(
  //       (m) => m.MaaMeetingComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MAA_MEETING_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/maa-meeting/maa-meeting-details/maa-meeting-details.component").then(
  //       (m) => m.MaaMeetingDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_TRANSACTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/iodine-testing/iodine-testing/iodine-testing.component").then(
  //       (m) => m.IodineTestingComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_TRANSACTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/iodine-testing/iodine-testing-details/iodine-testing-details.component").then(
  //       (m) => m.IodineTestingDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH}`,
  //   component: SpecingOfBirthComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_DETAILS}`,
  //   component: SpecingOfBirthDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // // contraceptive pills opening stock start
  // {
  //   path: `${SUBMENU_ID.CONTRACEPTIVE_PILLS_OPENING_STOCK_MASTER}`,
  //   component: ContraceptivePillsOpeningStockMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CONTRACEPTIVE_PILLS_OPENING_STOCK_MASTER_DETAILS}`,
  //   component: ContraceptivePillsOpeningStockMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // //contraceptive pills opening stock end

  // {
  //   path: `${SUBMENU_ID.TRANS_CONTRACEPTIVE_PILL}`,
  //   component: ContraceptivePillComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.TRANS_CONTRACEPTIVE_PILL_DETAILS}`,
  //   component: ContraceptivePillDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_KIT_TRANSACTION}`,
  //   component: HbncKitComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_KIT_TRANSACTION_DETAILS}`,
  //   component: HbncKitDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH}`,
  //   loadComponent: () =>
  //     import("./views/transaction/specing-of-birth/specing-of-birth/specing-of-birth.component").then(
  //       (m) => m.SpecingOfBirthComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/specing-of-birth/specing-of-birth-details/specing-of-birth-details.component").then(
  //       (m) => m.SpecingOfBirthDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // // contraceptive pills opening stock start
  // {
  //   path: `${SUBMENU_ID.CONTRACEPTIVE_PILLS_OPENING_STOCK_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/transaction/contraceptive-pills-opening-stock-master/contraceptive-pills-opening-stock-master/contraceptive-pills-opening-stock-master.component").then(
  //       (m) => m.ContraceptivePillsOpeningStockMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CONTRACEPTIVE_PILLS_OPENING_STOCK_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/contraceptive-pills-opening-stock-master/contraceptive-pills-opening-stock-master-details/contraceptive-pills-opening-stock-master-details.component").then(
  //       (m) => m.ContraceptivePillsOpeningStockMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // // contraceptive pills opening stock end

  // {
  //   path: `${SUBMENU_ID.TRANS_CONTRACEPTIVE_PILL}`,
  //   loadComponent: () =>
  //     import("./views/transaction/contraceptive-pill/contraceptive-pill/contraceptive-pill.component").then(
  //       (m) => m.ContraceptivePillComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.TRANS_CONTRACEPTIVE_PILL_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/contraceptive-pill/contraceptive-pill-details/contraceptive-pill-details.component").then(
  //       (m) => m.ContraceptivePillDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_KIT_TRANSACTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/hbnc-kit/hbnc-kit/hbnc-kit.component").then(
  //       (m) => m.HbncKitComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_KIT_TRANSACTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/hbnc-kit/hbnc-kit-details/hbnc-kit-details.component").then(
  //       (m) => m.HbncKitDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // Sanitary Napkin Packs Opening Balance start
  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_OPENING_STOCK}`,
  //   component: SanitaryNapkinPacksOpeningBalanceMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_OPENING_STOCK_DETAILS}`,
  //   component: SanitaryNapkinPacksOpeningBalanceDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // //Sanitary Napkin Packs Opening Balance end

  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_DISTRIBUTION}`,
  //   component: SanitaryNapkinDistributionComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_DISTRIBUTION_DETAILS}`,
  //   component: SanitaryNapkinDistributionDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.VISIT_FORM}`,
  //   component: VisitFormComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.VISIT_FORM_DETAILS}`,
  //   component: VisitFormDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_OPENING_STOCK}`,
  //   loadComponent: () =>
  //     import("./views/transaction/sanitary-napkin-packs-opening-balance/sanitary-napkin-packs-opening-balance-master/sanitary-napkin-packs-opening-balance-master.component").then(
  //       (m) => m.SanitaryNapkinPacksOpeningBalanceMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_OPENING_STOCK_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/sanitary-napkin-packs-opening-balance/sanitary-napkin-packs-opening-balance-details/sanitary-napkin-packs-opening-balance-details.component").then(
  //       (m) => m.SanitaryNapkinPacksOpeningBalanceDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // // Sanitary Napkin Distribution
  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_DISTRIBUTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/sanitary-napkin-distribution/sanitary-napkin-distribution/sanitary-napkin-distribution.component").then(
  //       (m) => m.SanitaryNapkinDistributionComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_DISTRIBUTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/sanitary-napkin-distribution/sanitary-napkin-distribution-details/sanitary-napkin-distribution-details.component").then(
  //       (m) => m.SanitaryNapkinDistributionDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // Visit Form
  // {
  //   path: `${SUBMENU_ID.VISIT_FORM}`,
  //   loadComponent: () =>
  //     import("./views/transaction/visit-form/visit-form/visit-form.component").then(
  //       (m) => m.VisitFormComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.VISIT_FORM_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/visit-form/visit-form-details/visit-form-details.component").then(
  //       (m) => m.VisitFormDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // Anemia Mukta Bharat opening stock start
  // {
  //   path: `${SUBMENU_ID.ANEMIA_MUKTA_BHARAT_OPENING_STOCK_MASTER}`,
  //   component: AnemiaMuktaBharatOpeningStockMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ANEMIA_MUKTA_BHARAT_OPENING_STOCK_MASTER_DETAILS}`,
  //   component: AnemiaMuktaBharatOpeningStockMasterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ANEMIA_MUKTA_BHARAT_DISTRIBUTION}`,
  //   component: AnemiaMuktaBharatComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ANEMIA_MUKTA_BHARAT_DISTRIBUTION_DETAILS}`,
  //   component: AnemiaMuktaBharatDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ANEMIA_MUKTA_BHARAT_OPENING_STOCK_MASTER}`,
  //   loadComponent: () =>
  //     import("./views/transaction/anemia-mukta-bharat-opening-stock-master/anemia-mukta-bharat-opening-stock-master/anemia-mukta-bharat-opening-stock-master.component").then(
  //       (m) => m.AnemiaMuktaBharatOpeningStockMasterComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ANEMIA_MUKTA_BHARAT_OPENING_STOCK_MASTER_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/anemia-mukta-bharat-opening-stock-master/anemia-mukta-bharat-opening-stock-master-details/anemia-mukta-bharat-opening-stock-master-details.component").then(
  //       (m) => m.AnemiaMuktaBharatOpeningStockMasterDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // // Distribution
  // {
  //   path: `${SUBMENU_ID.ANEMIA_MUKTA_BHARAT_DISTRIBUTION}`,
  //   loadComponent: () =>
  //     import("./views/transaction/anemia-mukta-bharat/anemia-mukta-bharat/anemia-mukta-bharat.component").then(
  //       (m) => m.AnemiaMuktaBharatComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ANEMIA_MUKTA_BHARAT_DISTRIBUTION_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/transaction/anemia-mukta-bharat/anemia-mukta-bharat-details/anemia-mukta-bharat-details.component").then(
  //       (m) => m.AnemiaMuktaBharatDetailsComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  //Anemia Mukta Bharat opening stock end
  // {
  //   path: 'Asha_Performance_Form',
  //   component: ,
  //   canActivate: [AuthGuardService]
  // },

  // {
  //   path: `${SUBMENU_ID.GRAM_HEALTH_SURVEY_REGISTER}`,
  //   component: GramHealthSurveyRegisterReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.FAMILY_SURVEY_REGISTER}`,
  //   component: FamilySurveyRegisterReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MAATA_REGISTER_REPORT}`,
  //   component: MaataRegisterReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ELIGIBLE_COUPLE_HISTORY_REPORT}`,
  //   component: EligibleCoupleReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.DETAILED_DEATHS_ABOVE_Five_REPORT}`,
  //   component: DetailedDeathsAboveFiveReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.PREMATURE_DEATHS_UNDER_FIVE_REPORT}`,
  //   component: PrematureDeathsUnderFiveComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.INFORMATION_ON_STILL_BIRTH_REPORT}`,
  //   component: InformationOnStillBirthReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.BIRTH_REGISTER_REPORT}`,
  //   component: BirthRegisterReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.NORMAL_MAATA_REGISTER_REPORT}`,
  //   component: NormalNormalMaataRegisterReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.GRAM_HEALTH_SURVEY_REGISTER}`,
    loadComponent: () =>
      import("./views/reports/gram-health-survey-register-report/gram-health-survey-register-report.component").then(
        (m) => m.GramHealthSurveyRegisterReportComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.FAMILY_SURVEY_REGISTER}`,
    loadComponent: () =>
      import("./views/reports/family-survey-register-report/family-survey-register-report.component").then(
        (m) => m.FamilySurveyRegisterReportComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.MAATA_REGISTER_REPORT}`,
    loadComponent: () =>
      import("./views/reports/high-risk-maata-register-report/high-risk-maata-register-report.component").then(
        (m) => m.HighRiskMaataRegisterReportComponent,
      ),
    canActivate: [AuthGuardService],
  },

  {
    path: `${SUBMENU_ID.ELIGIBLE_COUPLE_HISTORY_REPORT}`,
    loadComponent: () =>
      import("./views/reports/eligible-couple-report/eligible-couple-report.component").then(
        (m) => m.EligibleCoupleReportComponent,
      ),
    canActivate: [AuthGuardService],
  },

  {
    path: `${SUBMENU_ID.DETAILED_DEATHS_ABOVE_Five_REPORT}`,
    loadComponent: () =>
      import("./views/reports/detailed-deaths-above-five-report/detailed-deaths-above-five-report.component").then(
        (m) => m.DetailedDeathsAboveFiveReportComponent,
      ),
    canActivate: [AuthGuardService],
  },

  {
    path: `${SUBMENU_ID.PREMATURE_DEATHS_UNDER_FIVE_REPORT}`,
    loadComponent: () =>
      import("./views/reports/premature-deaths-under-five/premature-deaths-under-five.component").then(
        (m) => m.PrematureDeathsUnderFiveComponent,
      ),
    canActivate: [AuthGuardService],
  },

  {
    path: `${SUBMENU_ID.INFORMATION_ON_STILL_BIRTH_REPORT}`,
    loadComponent: () =>
      import("./views/reports/information-on-still-birth-report/information-on-still-birth-report.component").then(
        (m) => m.InformationOnStillBirthReportComponent,
      ),
    canActivate: [AuthGuardService],
  },

  {
    path: `${SUBMENU_ID.BIRTH_REGISTER_REPORT}`,
    loadComponent: () =>
      import("./views/reports/birth-register-report/birth-register-report.component").then(
        (m) => m.BirthRegisterReportComponent,
      ),
    canActivate: [AuthGuardService],
  },

  {
    path: `${SUBMENU_ID.NORMAL_MAATA_REGISTER_REPORT}`,
    loadComponent: () =>
      import("./views/reports/normal-maata-register-report/normal-maata-register-report.component").then(
        (m) => m.NormalNormalMaataRegisterReportComponent,
      ),
    canActivate: [AuthGuardService],
  },

  //Report

  // {
  //   path: 'Asha_Personal_Data',
  //   component: AshaTrainingFormComponent,
  //   canActivate: [AuthGuardService]
  // },
  // {
  //   path: `${SUBMENU_ID.AF_PROFILE_DATA}`,
  //   component: AfProfileDataComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_PROFILE_DATA}`,
  //   component: AshaProfileDataComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_PERFORMANCE_FORM_DETAILS}`,
  //   component: AshaTrainingFormReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BF_TRAINING_FORM_REPORT}`,
  //   component: AfTrainingFormReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_FORM_REPORT}`,
  //   component: AshaTrainingFormReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_SUMMARY_REPORT}`,
  //   component: AshaTrainingTransactionReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_TRAINING_TRANSACTION_REPORT}`,
  //   component: AFTrainingTransactionReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE_REPORT}`,
  //   component: CentralIncentiveReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_REPORT}`,
  //   component: StateIncentiveReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_PERFORMANCE_REPORT}`,
  //   component: AshaPerformanceReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_INCENTIVE_REPORT}`,
  //   component: AshaIncentiveComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_ASHA_INCENTIVE_REPORT}`,
  //   component: MonthlyIncentiveAshaReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BF_WISE_INCENTIVE_REPORT}`,
  //   component: AfWiseIncentiveReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.AF_PROFILE_DATA}`,
  //   loadComponent: () =>
  //     import("./views/reports/af-profile-data/af-profile-data/af-profile-data.component").then(
  //       (m) => m.AfProfileDataComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_PROFILE_DATA}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-profile-data/asha-profile-data.component").then(
  //       (m) => m.AshaProfileDataComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_PERFORMANCE_FORM_DETAILS}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-training-form-report/asha-training-form-report.component").then(
  //       (m) => m.AshaTrainingFormReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BF_TRAINING_FORM_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/af-training-form-report/af-training-form-report.component").then(
  //       (m) => m.AfTrainingFormReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_FORM_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-training-form-report/asha-training-form-report.component").then(
  //       (m) => m.AshaTrainingFormReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_TRAINING_SUMMARY_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-training-transaction-report/asha-training-transaction-report.component").then(
  //       (m) => m.AshaTrainingTransactionReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_TRAINING_TRANSACTION_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/af-training-transaction-report/af-training-transaction-report.component").then(
  //       (m) => m.AFTrainingTransactionReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CENTRAL_INCENTIVE_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/central-incentive-report/central-incentive-report.component").then(
  //       (m) => m.CentralIncentiveReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.STATE_INCENTIVE_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/state-incentive-report/state-incentive-report.component").then(
  //       (m) => m.StateIncentiveReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_PERFORMANCE_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-performance-report/asha-performance-report.component").then(
  //       (m) => m.AshaPerformanceReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_INCENTIVE_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-incentive/asha-incentive.component").then(
  //       (m) => m.AshaIncentiveComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_ASHA_INCENTIVE_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/monthly-incentive-asha-report/monthly-incentive-asha-report.component").then(
  //       (m) => m.MonthlyIncentiveAshaReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BF_WISE_INCENTIVE_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/af-wise incentive report/af-wise-incentive-report/af-wise-incentive-report.component").then(
  //       (m) => m.AfWiseIncentiveReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBNC_REPORT}`,
  //   component: HbncReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBNC_REPORT_MAIN}`,
  //   component: HbncReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MAA_MEETING_REPORT}`,
  //   component: MaaMeetingReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBYC_UNTRAINED_ASHA_REPORT}`,
  //   component: HbycUntrainedAshaComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.GRIEVANCE_MENTORING_REPORT}`,
  //   component: GrievanceMentoringTransactionReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_RAJYASHASAN_MANDHAN_REPORT}`,
  //   component: AfEmployeeStateIncentiveReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_RAJYASHASAN_MANDHAN_REPORT}`,
  //   component: AshaEmployeeStateIncentiveReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_AND_AF_POLICY_REPORT}`,
  //   component: AshaAndAfPolicyReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEVELOPMENTAL_DELAY_CHILDREN_REPORT}`,
  //   component: DevelopmentalDelayChildrenReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEFECTIVE_CHILDREN_REPORT}`,
  //   component: DefectiveChildrenReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_REPORT}`,
  //   component: IodineTestingReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RBSK_REPORT}`,
  //   component: RbskReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CUMULITIVE_RBSK_REPORT}`,
  //   component: CumulitiverbskReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_REPORT}`,
  //   component: SpacingOfBirthReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HR_REPORT}`,
  //   component: HrReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CONTRACEPTIVE_PILL_REPORT}`,
  //   component: ContraceptivePillReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.HBNC_KIT_REPORT}`,
  //   component: HbncKitReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_REPORT}`,
  //   component: SanitaryNapkinReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BCM_VISIT_RECORD_REPORT}`,
  //   component: BCMVisitFormReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_VISIT_RECORD_REPORT}`,
  //   component: AFVisitFormReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.FEATURE_GROUP}/:feature`, // 'Feature-Group'
  //   component: FeatureGroupComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.TOTAL_ASHA_TRAINED}`,
  //   component: TotalAshaTrainedComponent,
  //   canActivate: [AuthGuardService],
  // },

  // // New Component for dashboard
  // {
  //   path: `${SUBMENU_ID.ASHA_AF_EMPLOYEE_STATE_INCENTIVE_REPORT}`,
  //   component: AshaAfEmployeeStateIncentiveReportComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_ANEMIA_MUKTA_BHARAT}`,
  //   component: DashboardAnemiaMuktaBharatStockComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_ASHA_INCENTIVE}`,
  //   component: DashboardAshaIncentiveComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_CONTRACEPTIVE_PILLS}`,
  //   component: DashboardContraceptivePillsStockComponent,
  //   canActivate: [AuthGuardService],
  // },
  // // Asha central state incentives
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_ASHA_CENTRAL_STATE_INCENTIVE}`,
  //   component: DashboardAshaCentralStateIncentiveComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_AF_CENTRAL_STATE_INCENTIVE}`,
  //   component: DashboardAfCentralStateIncentiveComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_TOP_FIVE_ASHA_INCENTIVE}`,
  //   component: DashboardTopFiveAshaIncentiveComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_TOTAL_AHSA_REGISTERED}`,
  //   component: DashboardTotalAshaRegisteredComponent,
  //   canActivate: [AuthGuardService],
  // },
  // //  Asha_AF_Policy_Report
  // {
  //   path: `${SUBMENU_ID.ASHA_AF_POLICY_REPORT}`,
  //   component: AshaAndAfPolicyReportComponent,
  //   canActivate: [AuthGuardService],
  // },

  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBNC_REPORT_MAIN}`,
  //   loadComponent: () =>
  //     import("./views/reports/hbnc-report/hbnc-report.component").then(
  //       (m) => m.HbncReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MAA_MEETING_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/maa-meeting-report/maa-meeting-report.component").then(
  //       (m) => m.MaaMeetingReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MONTHLY_HBYC_UNTRAINED_ASHA_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/hbyc-untrained-asha/hbyc-untrained-asha.component").then(
  //       (m) => m.HbycUntrainedAshaComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.GRIEVANCE_MENTORING_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/grievance-mentoring-transaction-report/grievance-mentoring-transaction-report/grievance-mentoring-transaction-report.component").then(
  //       (m) => m.GrievanceMentoringTransactionReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_RAJYASHASAN_MANDHAN_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/af-employee-state-incentive-report/af-employee-state-incentive-report.component").then(
  //       (m) => m.AfEmployeeStateIncentiveReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_RAJYASHASAN_MANDHAN_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-employee-state-incentive-report/asha-employee-state-incentive-report.component").then(
  //       (m) => m.AshaEmployeeStateIncentiveReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.ASHA_AND_AF_POLICY_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-and-af-policy-report/asha-and-af-policy-report.component").then(
  //       (m) => m.AshaAndAfPolicyReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEVELOPMENTAL_DELAY_CHILDREN_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/developmental-delay-children-report/developmental-delay-children-report.component").then(
  //       (m) => m.DevelopmentalDelayChildrenReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEFECTIVE_CHILDREN_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/defective-children-report/defective-children-report/defective-children-report.component").then(
  //       (m) => m.DefectiveChildrenReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.IODINE_TESTING_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/iodine-testing-report/iodine-testing-report.component").then(
  //       (m) => m.IodineTestingReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.RBSK_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/rbsk-report/rbsk-report/rbsk-report.component").then(
  //       (m) => m.RbskReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CUMULITIVE_RBSK_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/rbsk-report/cumulitiverbsk-report/cumulitiverbsk-report.component").then(
  //       (m) => m.CumulitiverbskReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SPACING_OF_BIRTH_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/spacing-of-birth-report/spacing-of-birth-report.component").then(
  //       (m) => m.SpacingOfBirthReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HR_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/hr-report/hr-report.component").then(
  //       (m) => m.HrReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CONTRACEPTIVE_PILL_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/contraceptive-pill-report/contraceptive-pill-report.component").then(
  //       (m) => m.ContraceptivePillReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.HBNC_KIT_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/hbnc-kit-report/hbnc-kit-report.component").then(
  //       (m) => m.HbncKitReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.SANITARY_NAPKIN_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/sanitary-napkin-report/sanitary-napkin-report.component").then(
  //       (m) => m.SanitaryNapkinReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BCM_VISIT_RECORD_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/visit-form-report/bcm-visit-form-report/bcm-visit-form-report.component").then(
  //       (m) => m.BCMVisitFormReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.AF_VISIT_RECORD_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/visit-form-report/af-visit-form-report/af-visit-form-report.component").then(
  //       (m) => m.AFVisitFormReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // Dynamic Feature Group
  {
    path: `${SUBMENU_ID.FEATURE_GROUP}/:feature`,
    loadComponent: () =>
      import("./shared/components/feature-group/feature-group.component").then(
        (m) => m.FeatureGroupComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // {
  //   path: `${SUBMENU_ID.TOTAL_ASHA_TRAINED}`,
  //   loadComponent: () =>
  //     import("./views/common/total-asha-trained/total-asha-trained.component").then(
  //       (m) => m.TotalAshaTrainedComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // Dashboard
  // {
  //   path: `${SUBMENU_ID.ASHA_AF_EMPLOYEE_STATE_INCENTIVE_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-af-employee-state-incentive-report/asha-af-employee-state-incentive-report.component").then(
  //       (m) => m.AshaAfEmployeeStateIncentiveReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_ANEMIA_MUKTA_BHARAT}`,
  //   loadComponent: () =>
  //     import("./views/common/dashboard-anemia-mukta-bharat-stock/dashboard-anemia-mukta-bharat-stock.component").then(
  //       (m) => m.DashboardAnemiaMuktaBharatStockComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_ASHA_INCENTIVE}`,
  //   loadComponent: () =>
  //     import("./views/common/dashboard-asha-incentive/dashboard-asha-incentive.component").then(
  //       (m) => m.DashboardAshaIncentiveComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_CONTRACEPTIVE_PILLS}`,
  //   loadComponent: () =>
  //     import("./views/common/dashboard-contraceptive-pills-stock/dashboard-contraceptive-pills-stock.component").then(
  //       (m) => m.DashboardContraceptivePillsStockComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_ASHA_CENTRAL_STATE_INCENTIVE}`,
  //   loadComponent: () =>
  //     import("./views/common/dashboard-asha-central-state-incentive/dashboard-asha-central-state-incentive.component").then(
  //       (m) => m.DashboardAshaCentralStateIncentiveComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_AF_CENTRAL_STATE_INCENTIVE}`,
  //   loadComponent: () =>
  //     import("./views/common/dashboard-af-central-state-incentive/dashboard-af-central-state-incentive.component").then(
  //       (m) => m.DashboardAfCentralStateIncentiveComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_TOP_FIVE_ASHA_INCENTIVE}`,
  //   loadComponent: () =>
  //     import("./views/common/dashboard-top-five-asha-incentive/dashboard-top-five-asha-incentive.component").then(
  //       (m) => m.DashboardTopFiveAshaIncentiveComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DASHBOARD_TOTAL_AHSA_REGISTERED}`,
  //   loadComponent: () =>
  //     import("./views/common/dashboard-total-asha-registered/dashboard-total-asha-registered.component").then(
  //       (m) => m.DashboardTotalAshaRegisteredComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  // Duplicate logical route (kept same component)
  // {
  //   path: `${SUBMENU_ID.ASHA_AF_POLICY_REPORT}`,
  //   loadComponent: () =>
  //     import("./views/reports/asha-and-af-policy-report/asha-and-af-policy-report.component").then(
  //       (m) => m.AshaAndAfPolicyReportComponent,
  //     ),
  //   canActivate: [AuthGuardService],
  // },

  //New Component Religion Master
  // {
  //   path: `${SUBMENU_ID.RELIGION_MASTER}`,
  //   component: ReligionMasterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // // new transaction family registration
  // {
  //   path: `${SUBMENU_ID.FAMILY_REGISTRATION}`,
  //   component: FamilyRegistrationComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.FAMILY_REGISTRATION_DETAILS}`,
  //   component: FamilyRegistrationDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.FAMILY_MEMBER}`,
  //   component: FamilyMemberComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.CHANGE_HEAD_OF_FAMILY}`,
  //   component: ChangeHeadOfFamilyComponent,
  //   canActivate: [AuthGuardService],
  // },
  // // Split Family
  // {
  //   path: `${SUBMENU_ID.SPLIT_FAMILY_DETAILS}`,
  //   component: SplitFamilyDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // // new Eligible Couple
  // {
  //   path: `${SUBMENU_ID.Eligible_Couple}`,
  //   component: EligibleCoupleComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.Eligible_Couple_DETAILS}`,
  //   component: EligibleCoupleDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // // Maata Register
  // {
  //   path: `${SUBMENU_ID.MAATA_REGISTER}`,
  //   component: MaataRegisterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.MAATA_REGISTER_DETAILS}`,
  //   component: MaataRegisterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // // Birth Register
  // {
  //   path: `${SUBMENU_ID.BIRTH_REGISTER}`,
  //   component: BirthRegisterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.BIRTH_REGISTER_DETAILS}`,
  //   component: BirthRegisterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  // // Death Register
  // {
  //   path: `${SUBMENU_ID.DEATH_REGISTER}`,
  //   component: DeathRegisterComponent,
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: `${SUBMENU_ID.DEATH_REGISTER_DETAILS}`,
  //   component: DeathRegisterDetailsComponent,
  //   canActivate: [AuthGuardService],
  // },

  {
    path: `${SUBMENU_ID.RELIGION_MASTER}`,
    loadComponent: () =>
      import("./views/Masters/religion-master/religion-master/religion-master.component").then(
        (m) => m.ReligionMasterComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // Family Registration
  {
    path: `${SUBMENU_ID.FAMILY_REGISTRATION}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/family-registration/family-registration.component").then(
        (m) => m.FamilyRegistrationComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.FAMILY_REGISTRATION_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/family-registration-details/family-registration-details.component").then(
        (m) => m.FamilyRegistrationDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.FAMILY_MEMBER}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/family-member/family-member.component").then(
        (m) => m.FamilyMemberComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.CHANGE_HEAD_OF_FAMILY}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/change-head-of-family/change-head-of-family.component").then(
        (m) => m.ChangeHeadOfFamilyComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // Split Family
  {
    path: `${SUBMENU_ID.SPLIT_FAMILY_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/split-family-details/split-family-details.component").then(
        (m) => m.SplitFamilyDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // Eligible Couple
  {
    path: `${SUBMENU_ID.Eligible_Couple}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/eligible-couple/eligible-couple/eligible-couple.component").then(
        (m) => m.EligibleCoupleComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.Eligible_Couple_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/eligible-couple/eligible-couple-details/eligible-couple-details.component").then(
        (m) => m.EligibleCoupleDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },


  
  // HBNC Register
  {
    path: `${SUBMENU_ID.HBNC_REGISTER}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/hbnc-register/hbnc-register/hbnc-register.component").then(
        (m) => m.HbncRegisterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.HBNC_REGISTER_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/hbnc-register/hbnc-register-details/hbnc-register-details.component").then(
        (m) => m.HbncRegisterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

   // HBYC Register
  {
    path: `${SUBMENU_ID.HBYC_REGISTER}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/hbyc-register/hbyc-register/hbyc-register.component").then(
        (m) => m.HbycRegisterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.HBYC_REGISTER_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/family-registration/hbyc-register/hbyc-register-details/hbyc-register-details.component").then(
        (m) => m.HbycRegisterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },



  // Maata Register
  {
    path: `${SUBMENU_ID.MAATA_REGISTER}`,
    loadComponent: () =>
      import("./views/transaction/maata-register/maata-register/maata-register.component").then(
        (m) => m.MaataRegisterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.MAATA_REGISTER_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/maata-register/maata-register-details/maata-register-details.component").then(
        (m) => m.MaataRegisterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // Birth Register
  {
    path: `${SUBMENU_ID.BIRTH_REGISTER}`,
    loadComponent: () =>
      import("./views/transaction/birth-register/birth-register/birth-register.component").then(
        (m) => m.BirthRegisterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.BIRTH_REGISTER_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/birth-register/birth-register-details/birth-register-details.component").then(
        (m) => m.BirthRegisterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

  // Death Register
  {
    path: `${SUBMENU_ID.DEATH_REGISTER}`,
    loadComponent: () =>
      import("./views/transaction/death-register/death-register/death-register.component").then(
        (m) => m.DeathRegisterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.DEATH_REGISTER_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/death-register/death-register-details/death-register-details.component").then(
        (m) => m.DeathRegisterDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },


    // Child Immunization Register
  {
    path: `${SUBMENU_ID.CHILD_IMMUNIZATION}`,
    loadComponent: () =>
      import("./views/transaction/child-immunization/child-immunization/child-immunization.component").then(
        (m) => m.ChildImmunizationComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.CHILD_IMMUNIZATION_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/child-immunization/child-immunization-details/child-immunization-details.component").then(
        (m) => m.ChildImmunizationDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },

  
    // NCD CBAC Register
  {
    path: `${SUBMENU_ID.NCD_CBAC_REGISTER}`,
    loadComponent: () =>
      import("./views/transaction/ncd-cbac-register/ncd-cbac-register/ncd-cbac-register.component").then(
        (m) => m.NcdCbacRegisterComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: `${SUBMENU_ID.NCD_CBAC_REGISTER_DETAILS}`,
    loadComponent: () =>
      import("./views/transaction/child-immunization/child-immunization-details/child-immunization-details.component").then(
        (m) => m.ChildImmunizationDetailsComponent,
      ),
    canActivate: [AuthGuardService],
  },


  {
    path: "Notification",
    component: NotificationComponent,
    // canActivate: [AuthGuardService]
  },
  // inbuild component
  {
    path: "home",
    component: DashboardComponent,
    canActivate: [AuthGuardService],
  },

  //  {
  //   path: "home",
  //   component: FamilyRegistrationDashboardComponent,
  //   canActivate: [AuthGuardService],
  // },
  {
    path: "login-form",
    component: LoginFormComponent,
    // canActivate: [AuthGuardService]
  },
  {
    path: `${SUBMENU_ID.PRIVACY_POLICY}`,
    component: PrivacyPolicyComponent,
    // canActivate: [AuthGuardService]
  },
  {
    path: `${SUBMENU_ID.TERMS_AND_CONDITIONS}`,
    component: TermsAndConditionsComponent,
    // canActivate: [AuthGuardService]
  },
  {
    path: "reset-password",
    component: ResetPasswordFormComponent,
    // canActivate: [AuthGuardService]
  },
  {
    path: "create-account",
    component: CreateAccountFormComponent,
    // canActivate: [AuthGuardService]
  },
  {
    path: "otp-verification",
    component: OTPFormComponent,
    // canActivate: [AuthGuardService]
  },
  {
    path: "create-new-password",
    component: NewPasswordFormComponent,
    // canActivate: [AuthGuardService]
  },

  {
    path: "change-password/:recoveryCode",
    component: ChangePasswordFormComponent,
    // canActivate: [AuthGuardService]
  },

  // LANDING PAGE
  {
    path: "Landing_Page",
    component: LandingPageComponent,
    // canActivate: [AuthGuardService],
  },
  // {
  //   path: "",
  //   redirectTo: "login-form",
  //   pathMatch: "full",
  // },
  // {
  //   path: "**",
  //   redirectTo: "login-form",
  // },
  // BEFORE
  {
    path: "",
    redirectTo: "Landing_Page",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: "Landing_Page", // ✅ change this
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
    DxDataGridModule,
    DxFormModule,
  ],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: [HomeComponent, TasksComponent],
})
export class AppRoutingModule {}
